import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=461fd604&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=461fd604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461fd604",
  null
  
)

export default component.exports